import React from 'react';
import { ArcSkeleton, ArcStack } from '@src/core/ui';

const ControllerPageLoading: React.FC = () => {
  return (
    <ArcStack p={8} pt={6} spacing={4}>
      <ArcStack direction='row' alignItems='center' justifyContent='space-between'>
        <ArcSkeleton width={250} height={36} />
        <ArcSkeleton width={100} height={36} />
      </ArcStack>

      <ArcSkeleton width='100%' height={300} />

      <ArcStack direction='row' spacing={6}>
        <ArcStack spacing={3} flex={1}>
          <ArcSkeleton width={180} height={28} />
          <ArcStack spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
            <ArcSkeleton width={150} height={20} />
            <ArcSkeleton width={250} height={45} />
          </ArcStack>
          <ArcSkeleton width='100%' height={200} />
          {Array.from({ length: 4 }).map((_, i) => (
            <ArcStack key={i} spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
              <ArcSkeleton width={180} height={20} />
              <ArcSkeleton width={250} height={45} />
            </ArcStack>
          ))}
        </ArcStack>

        <ArcStack spacing={3} flex={1}>
          <ArcSkeleton width={180} height={28} />
          {Array.from({ length: 12 }).map((_, i) => (
            <ArcStack key={i} spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
              <ArcSkeleton width={120} height={20} />
              <ArcSkeleton width={250} height={45} />
            </ArcStack>
          ))}
        </ArcStack>
      </ArcStack>
    </ArcStack>
  );
};

export default ControllerPageLoading;
